module.exports = __webpack_public_path__ + "media/images/elionline/icons/not-available-on-mobile-00b8a5a6cd6b220a8d8e848a2d696797.png";